import { render, staticRenderFns } from "./PendingNotes.vue?vue&type=template&id=47bfdcc3"
import script from "./PendingNotes.vue?vue&type=script&lang=js"
export * from "./PendingNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports